/* Tick: changes pose every few seconds and reacts to a click. */
(function () {
  var poses = window.FB_TICK || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IDLE_MS = 7000;
  var REACT_MS = 1500;

  function show(img, pose) {
    if (!poses[pose] || img.getAttribute('src') === poses[pose]) return;
    img.src = poses[pose];
    img.classList.remove('is-popping');
    void img.offsetWidth;
    img.classList.add('is-popping');
  }

  document.querySelectorAll('[data-tick]').forEach(function (tick) {
    var img = tick.querySelector('.d-tick__img');
    var button = tick.querySelector('.d-tick__btn');
    var cycle = [tick.dataset.pose].concat(
      (tick.dataset.idle || '').split(',').filter(Boolean)
    );
    var index = 0;
    var reacting = false;

    if (!reduced && cycle.length > 1) {
      setInterval(function () {
        if (reacting || document.hidden) return;
        index = (index + 1) % cycle.length;
        show(img, cycle[index]);
      }, IDLE_MS);
    }

    button.addEventListener('click', function () {
      reacting = true;
      show(img, 'hype');
      setTimeout(function () {
        reacting = false;
        show(img, cycle[index]);
      }, REACT_MS);
    });
  });
})();
